import { render, staticRenderFns } from "./HiresList.vue?vue&type=template&id=6ee56ce2&"
import script from "./HiresList.vue?vue&type=script&lang=js&"
export * from "./HiresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports